export const en = {
  nav: {
    home: "Home",
    about: "About",
    services: "Services",
    doctors: "Doctors",
    branches: "Branches",
    gallery: "Gallery",
    contact: "Contact",
    bookAppointment: "Book Appointment",
    call: "Call",
    whatsapp: "WhatsApp",
    book: "Book"
  },
  hero: {
    society: "SREE TEKKE EYE CLINIC & SIGHT CARE SOCIETY",
    titleLine1: "Clear Vision.",
    titleLine2: "Better Care.",
    description: "Professional eye care, centred on you. Explore thoughtful services and connect with our team across 6 branches.",
    bookAppointment: "Book Appointment",
    callNow: "Call Now",
    whatsapp: "WhatsApp",
    tagline: "Eye care with a human touch",
    counter: "01 / 03"
  },
  features: {
    f1Title: "Focused on eye health",
    f1Desc: "Care centred around your vision",
    f2Title: "Patient-first approach",
    f2Desc: "Thoughtful care at every step",
    f3Title: "6 branch locations",
    f3Desc: "Eye care closer to your community",
    f4Title: "Care for every age",
    f4Desc: "From children to adults"
  },
  trust: {
    happyPatients: "Happy Patients",
    expertDoctors: "Expert Doctors",
    yearsExperience: "Years Experience",
    advancedBranches: "Advanced Branches"
  },
  servicesSection: {
    badge: "Our Services",
    title: "Care for every perspective.",
    subtitle: "Advanced eye care technologies and expert ophthalmologists dedicated to restoring and enhancing your vision. We offer 16+ specialized treatments.",
    viewAll: "View all services",
    learnMore: "Learn more",
    bookNow: "Book Now",
    bookConsultation: "Book Consultation",
    enquire: "Enquire",
    pageBadge: "Specialized Treatments • 16 Advanced Eye Care Services",
    pageTitle: "Our Services",
    pageSubtitle: "We offer a comprehensive range of advanced eye care treatments and surgical procedures using cutting-edge technology. From routine diagnostics to complex microsurgeries, your vision is in expert hands."
  },
  doctorsSection: {
    badge: "Our Specialists",
    title: "Get to know your doctors.",
    subtitle: "Meet the professionals at the heart of your care.",
    meetDoctors: "Meet our doctors",
    specialistTag: "Eye Care Specialist",
    portraitPlaceholder: "Portrait to be added",
    bookConsultation: "Book consultation",
    pageTitle: "Our Specialists",
    pageSubtitle: "Meet our team of experienced ophthalmologists and eye surgeons. We are dedicated to providing you with the highest standard of personalized eye care."
  },
  branchesSection: {
    badge: "Our Network",
    locationsCount: "6 Locations",
    title: "Care, a little closer.",
    subtitle: "Find a modern eye clinic near you across Maharashtra & Karnataka with specialized diagnostics and surgical facilities.",
    viewAll: "View all locations",
    openToday: "Open Today",
    filterDistrict: "Filter District:",
    allCenters: "All Centers",
    allCentersOpen: "All 6 Centers Open Today",
    dailyOpd: "Daily OPD: 9 AM - 8 PM",
    branchPrefix: "Branch",
    of: "of",
    tekkeCenter: "Tekke Center",
    viewDetails: "View details",
    call: "Call",
    map: "Map",
    details: "Details",
    contactNo: "Contact No",
    pageHeroBadge: "Locations",
    pageHeroTitle: "Our Network of Care.",
    pageHeroSubtitle: "With 6 state-of-the-art facilities across Maharashtra & Karnataka, world-class eye care is always within your reach.",
    statClinics: "6 Clinics",
    statClinicsDesc: "Astha, Jath, Atpadi, Solapur, Athani & Sangola",
    statBooking: "24/7 Booking",
    statBookingDesc: "Online & WhatsApp",
    findOnMap: "Find Us on the Map",
    navigate: "Navigate",
    branchInfo: "Branch Information",
    address: "Address",
    timings: "Timings",
    availableFacilities: "Available Facilities",
    callBranch: "Call",
    whatsappMessage: "WhatsApp Message",
    doctorsAtBranch: "Specialists at this Branch",
    bookAtBranch: "Book an Appointment at this Branch",
    exploreAllMob: "Explore All 6 Branches & Maps"
  },
  missionSection: {
    badge: "Sight Care Society",
    title: "Looking beyond the clinic.",
    desc: "Our Sight Care Society is dedicated to providing free eye camps, awareness programs, and subsidized surgeries for those in need. We believe clear vision is a fundamental right.",
    findOutMore: "Find out more about us"
  },
  gallerySection: {
    badge: "Gallery",
    title: "Inside our world of care.",
    subtitle: "A glimpse into our facilities, technologies, and patient care.",
    viewFull: "View full gallery",
    pageTitle: "Our Gallery",
    pageSubtitle: "Explore our advanced eye care facilities, dedicated medical team, community health camps, and modern infrastructure across our branches.",
    photos: "Photos",
    all: "All",
    campBadge: "Community Camp",
    clinicBadge: "Clinic & OT",
    close: "Close",
    prev: "Previous",
    next: "Next"
  },
  contactSection: {
    badge: "Contact Us",
    title: "We're here when you need us.",
    subtitle: "Our team is always ready to assist you. Get in touch with us for any queries, feedback, or emergencies.",
    mainClinicBadge: "Main Clinic Location",
    mainClinicTitle: "Sree Tekke Eye Clinic",
    mainClinicLocation: "Sangli, Maharashtra",
    openInMaps: "Open in Google Maps",
    getInTouch: "Get in touch",
    exploreAllBranches: "Explore All Branches",
    pageTitle: "Contact Us",
    pageSubtitle: "We're here to help. Reach out to us for any inquiries, appointments, or emergency eye care needs.",
    mainClinic: "Main Clinic",
    address: "Address",
    phone: "Phone",
    whatsapp: "WhatsApp",
    email: "Email",
    workingHours: "Working Hours",
    monSatHours: "Mon - Sat: 9:00 AM - 8:00 PM",
    sundayHours: "Sunday: Closed",
    callNow: "Call Now",
    messageUs: "Message Us",
    sendEmail: "Send Email",
    name: "Full Name *",
    phoneNumber: "Phone Number *",
    emailAddress: "Email Address",
    subject: "Subject",
    message: "Message *",
    submitEnquiry: "Submit Enquiry",
    namePlaceholder: "John Doe",
    phonePlaceholder: "+91 98765 43210",
    emailPlaceholder: "john@example.com",
    subjectPlaceholder: "How can we help?",
    messagePlaceholder: "Please describe your inquiry...",
    contactSuccess: "Thank you for your message. We will get back to you shortly."
  },
  appointmentSection: {
    pageTitle: "Book an Appointment",
    formTitle: "Request an Appointment",
    formSubtitle: "Fill out the form below and we will get back to you promptly.",
    fullName: "Full Name *",
    phone: "Phone Number *",
    email: "Email Address",
    selectBranch: "Select Branch *",
    chooseBranch: "Choose a branch...",
    selectDoctor: "Select Doctor (Optional)",
    chooseDoctor: "Choose a doctor...",
    otherDoctor: "Other Doctor",
    enterDoctorName: "Enter Doctor Name",
    selectService: "Select Service (Optional)",
    chooseService: "Choose a service...",
    preferredDate: "Preferred Date *",
    preferredTime: "Preferred Time *",
    chooseTime: "Choose a time slot...",
    morning: "Morning (9:00 AM - 1:00 PM)",
    afternoon: "Afternoon (1:00 PM - 5:00 PM)",
    evening: "Evening (5:00 PM - 8:00 PM)",
    message: "Additional Notes (Optional)",
    messagePlaceholder: "Any specific concerns or medical history...",
    submitBtn: "Book Appointment Now",
    submitting: "Submitting...",
    successMsg: "Thank you for booking an appointment. Our team will contact you shortly to confirm the details."
  },
  aboutSection: {
    heroTitle1: "Pioneering",
    heroTitle2: "Vision Care",
    heroP1: "Sree Tekke Eye Clinic was founded with a singular mission: to provide world-class, accessible eye care to our community. For decades, we have been at the forefront of ophthalmic excellence.",
    heroP2: "Guided by the expertise of Dr. Ramakant Tekke and Dr. Vishakha Tekke, our clinic combines advanced medical technology with a deeply compassionate approach to patient care.",
    meetDoctors: "Meet Our Doctors",
    guidingPrinciples: "Our Guiding Principles",
    missionVisionTitle: "Our Mission & Vision",
    missionVisionSub: "Empowering communities with crystal-clear vision, ethical medicine, and state-of-the-art ophthalmic care.",
    missionTitle: "Our Mission",
    ourPurpose: "Our Purpose",
    missionText: "At Shree Teke Eye Clinic, Sangli, our mission is to provide comprehensive, advanced, and affordable eye care that preserves, restores, and enhances vision for patients of all ages. We are committed to accurate diagnosis, ethical medical practices, and compassionate care—helping every patient achieve better eyesight and an improved quality of life through modern eye care solutions.",
    visionTitle: "Our Vision",
    ourAspiration: "Our Aspiration",
    visionText: "To be recognized as a trusted center of excellence in ophthalmology, delivering the highest standard of clinical and surgical eye care. We aim to eradicate preventable blindness and promote lifelong eye health through cutting-edge technology, continuous clinical advancement, and community outreach.",
    tagAccurate: "Accurate Diagnosis",
    tagEthical: "Ethical Practices",
    tagAffordable: "Affordable Care",
    tagAdvanced: "Advanced Technology",
    tagExcellence: "Clinical Excellence",
    tagCommunity: "Community Outreach"
  },
  footer: {
    brandDesc: "Clear Vision. Better Care. Dedicated to state-of-the-art stitchless cataract surgery, laser vision correction, and comprehensive clinical care across 6 branches.",
    nabhCare: "NABH Standard Care",
    modernCenters: "6 Modern Centers",
    connectWithUs: "Connect With Us",
    quickLinks: "Quick Links",
    ourBranches: "Our Branches",
    popularServices: "Popular Treatments",
    needHelp: "Need Immediate Care?",
    callEmergency: "Emergency Helpline",
    whatsappConsult: "WhatsApp Consultation",
    dailyOpd: "Daily OPD Timings",
    dailyOpdHours: "Mon - Sat: 9:00 AM - 8:00 PM",
    allRightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    chooseLanguage: "Language"
  },
  servicesList: {
    "lasik-laser": {
      name: "Lasik Laser Vision Correction",
      category: "Refractive Surgery",
      description: "Advanced blade-free laser vision correction to permanently remove spectacle numbers and achieve crystal-clear sight without glasses."
    },
    "multifocal-lens": {
      name: "Multifocal Lens Implants",
      category: "Lens Implants",
      description: "Premium intraocular lens (IOL) implants providing clear, seamless visual focus for near, intermediate, and distance vision without reading glasses."
    },
    "phaco-surgery": {
      name: "Phacoemulsification Surgery",
      category: "Cataract Care",
      description: "State-of-the-art micro-incision ultrasound cataract surgery ensuring high precision, gentle lens removal, and rapid visual recovery."
    },
    "stitchless-cataract-surgery": {
      name: "Stitchless Cataract Surgery (MICS)",
      category: "Cataract Care",
      description: "Painless, no-injection, and stitchless cataract surgery combined with foldable intraocular lens implantation for same-day recovery."
    },
    "glaucoma-treatment": {
      name: "Glaucoma Treatment & Surgery",
      category: "Glaucoma",
      description: "Early detection of elevated intraocular pressure, continuous visual field analysis, medical management, and advanced glaucoma filtration surgery."
    },
    "squint-treatment": {
      name: "Squint (Strabismus) Surgery & Correction",
      category: "Pediatric & Strabismus",
      description: "Comprehensive diagnostic assessment, specialized orthoptic exercises, and precision corrective eye muscle surgery for children and adults."
    },
    "oct-retina-screening": {
      name: "OCT 3D Retinal Imaging & Diagnosis",
      category: "Diagnostic Imaging",
      description: "High-definition Optical Coherence Tomography (OCT) scanning providing cross-sectional 3D imaging of retinal layers and the optic nerve head."
    },
    "retina-disorders-surgery": {
      name: "Retinal Disorders Diagnosis & Surgery",
      category: "Vitreoretinal Care",
      description: "Expert vitreoretinal diagnosis, retinal detachment repair, macular hole surgeries, and targeted retinal laser photocoagulation."
    },
    "oculoplastic-surgery": {
      name: "Oculoplastic & Eyelid Surgery",
      category: "Reconstructive Surgery",
      description: "Specialized reconstructive and cosmetic surgery of the eyelids, tear drainage system, and orbit, including ptosis repair and blepharoplasty."
    },
    "pediatric-eye-surgery": {
      name: "Pediatric Eye Care & Surgeries",
      category: "Pediatric Care",
      description: "Compassionate, specialized ophthalmic care for infants and children, treating congenital cataracts, lazy eye (amblyopia), and refractive errors."
    },
    "contact-lens-facility": {
      name: "Specialty Contact Lens Clinic",
      category: "Optical Care",
      description: "Customized consultation and precise clinical fitting for soft, toric, multifocal, rigid gas permeable (RGP), and prosthetic contact lenses."
    },
    "lasru-dcr-surgery": {
      name: "Lasru / DCR Tear Duct Surgery",
      category: "Lacrimal Surgery",
      description: "Advanced medical treatment and minimally invasive dacryocystorhinostomy (DCR) surgery to resolve chronic tearing and blocked tear ducts."
    },
    "computerized-vision-testing": {
      name: "Computerized Vision & Refraction Testing",
      category: "Diagnostic Testing",
      description: "Fast, fully automated autorefraction and digital keratometry to ensure pinpoint accuracy for spectacle and vision correction prescriptions."
    },
    "diabetic-retinopathy": {
      name: "Diabetic Retinopathy Diagnosis & Treatment",
      category: "Vitreoretinal Care",
      description: "Comprehensive diabetic eye screenings, specialized green retinal laser therapy, and advanced intravitreal anti-VEGF injections."
    },
    "general-eye-care": {
      name: "Comprehensive Eye Care & Treatment",
      category: "General Ophthalmology",
      description: "Expert evaluation and clinical treatment for eye infections, ocular allergies, dry eye syndrome, foreign body removal, and acute injuries."
    },
    "cornea-disorders-surgery": {
      name: "Corneal Disorders & Surgery",
      category: "Cornea Care",
      description: "Specialized clinical care for corneal ulcers, keratoconus collagen cross-linking (C3R), pterygium excision, and corneal transplant procedures."
    }
  },
  branchList: {
    astha: {
      name: "Sree Teke Eye Clinic, Astha",
      city: "Astha",
      area: "Astha",
      address: "Near by Rukade Petrol Pump, Swagat Hotel, 1st floor, Main Road, Astha",
      facilities: ["Advanced Eye OPD", "Optical Store", "Cataract Evaluation", "Computerized Vision Check"]
    },
    jath: {
      name: "Sree Teke Eye Clinic, Jath",
      city: "Jath",
      area: "Jath",
      address: "Near by Rukade Petrol Jal wadi complex, Jath",
      facilities: ["Consultation Rooms", "Optical Center", "Refraction Testing", "Pharmacy"]
    },
    atpadi: {
      name: "Sree Teke Eye Clinic, Atpadi",
      city: "Atpadi",
      area: "Atpadi",
      address: "Near by S.T. Stand, top of Roweat Hospital, Atpadi",
      facilities: ["Comprehensive Eye Care", "Optical Store", "Diagnostic Facilities"]
    },
    solapur: {
      name: "Raghvendra Sree Teke Eye Clinic, Solapur",
      city: "Solapur",
      area: "Solapur",
      address: "Maji sainik nagar, Vijapur road, Solapur",
      facilities: ["Advanced Surgical Unit", "Laser Treatment", "Optical Store", "Diagnostic Center"]
    },
    athani: {
      name: "Sree Teke Eye Clinic, Athani",
      city: "Athani",
      area: "Athani",
      address: "Shantinagar Halyal Crucial Road, Athani",
      facilities: ["Consultation Rooms", "Optical Store", "Pediatric Eye Check"]
    },
    sangola: {
      name: "Sree Teke Eye Clinic, Sangola",
      city: "Sangola",
      area: "Sangola",
      address: "Mauli Hights, Miraj road, Near Gauri Patrol Pump, Sangola",
      facilities: ["Full Eye Checkup", "Optical Dispensing", "Pharmacy", "Minor OT"]
    }
  },
  doctorsList: {
    "dr-ramakant-tekke": {
      name: "Dr. Ramakant Tekke",
      qualification: "Ophthalmology",
      specialization: "Ophthalmologist",
      profile: "A highly experienced ophthalmologist dedicated to providing comprehensive eye care and advanced surgical treatments."
    },
    "dr-vishakha-tekke": {
      name: "Dr. Vishakha Tekke",
      qualification: "M.S. (Opth) & M.B.B.S., D.O.M.S.",
      specialization: "Ophthalmologist & Eye Surgeon",
      profile: "Specializes in modern vision correction procedures, cataract surgery, and comprehensive patient eye care."
    }
  }
};
